// This file is used to configure cometd and define its related functions for SENDING COMETD events from chat-bot
import HWUser from "../Simplify360Chat/HWLibrary/HWUser";
import { s360ConfigService } from "../Simplify360Chat/Services/S360Config";
import { DEFAULT_USER_DATA } from "../utils/Constants/Constants";
import uuid from "react-uuid";

export const CometdActions = (cometd, userData = DEFAULT_USER_DATA) => {
  const sendURl = "/cometd-server-channel";

  const sendMessage = (sessionId, messageData, convoType) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CUSTOMER_REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendAckAgentMessage = (sessionId, messageData, convoType) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_AGENT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const sendBotAckMessage = (sessionId, messageData, convoType) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "ACK_BOT_REPLY",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE ACK AGENT REPLY", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchConversations = (limit, lastFetchedSession) => {
    const customerId = userData.customerId
    const clientUser = userData.clientChannel
    const params = {
      configId: s360ConfigService.config.configId,
      command: "GET_SESSIONS_REQUEST",
      customerId,
      convoType: "TEXT",
      clientUser: clientUser === undefined && clientUser === null ? sessionStorage.getItem("cu") : clientUser ,
      fromUi: false,
      assignedTo: -1,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuid,
    };
    params["limit"] = limit || 30;
    params["sourceType"] = userData.sourceType || 60;
    if (lastFetchedSession) {
      params["sessionInfo"] = lastFetchedSession;
    }

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR GET_SESSION_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const fetchHistory = (sessionInfo, fromId, limit) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const params = {
      configId: s360ConfigService.config.configId,
      customerId,
      command: "HISTORY_REQUEST",
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      firstMessageTimestamp: 0,
      sessionInfo,
      sourceType,
      isJabber: false,
      fromApi: false,
    };
    if (fromId) {
      params["fromId"] = fromId;
    }
    if (limit) {
      params["limit"] = limit;
    }
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR HISTORY_REQUEST", params);
      if (message) {
        return message;
      }
    });
  };

  const createSession = (restartButtonClicked = false) => {
    const customerId = userData.customerId
    const clientUser = userData.clientChannel
    const sourceType = userData.sourceType
    const clientCode = userData.clientCode || null
    const params = {
      configId: s360ConfigService.config.configId,
      command: "CREATE_SESSION",
      customerId,
      convoType: "TEXT",
      clientUser,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      restartButtonClicked,
      userAgent: s360ConfigService.userData.userAgent,
      clientCode
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CREATE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const updateHistory = (sessionId) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "UPDATE_HISTORY",
      customerId,
      customerFirstName,
      customerLastName,
      appId,
      sourceType,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR UPDATE_HISTORY ", params);
      if (message) {
        return message;
      }
    });
  };

  const saveUserMetaData = (userDetails, sessionId) => {
    const params = {
      sessionId: sessionId,
      command: "SAVE_USER_DETAILS",
      userDetails: userDetails,
      isJabber: false,
      fromApi: false,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR SAVE_USER_DETAILS", params);
      if (message) {
        return message;
      }
    });
  };

  const closeSession = (sessionId) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "SESSION_CLOSE_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CLOSE_SESSION", params);
      if (message) {
        return message;
      }
    });
  };

  const changeLanguage = (sessionId, language) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const params = {
      configId: s360ConfigService.config.configId,
      sessionId: sessionId,
      command: "CHANGE_LANGUAGE",
      customerId,
      changeLanguage: language,
      customerFirstName: s360ConfigService.config.configId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
      creator: "CUSTOMER",
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR LANGUAGE CHANGE", params);
      if (message) {
        return message;
      }
    });
  };

  const sendChatTranscript = (sessionInfo, emailId) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const params = {
      configId: s360ConfigService.config.configId,
      sessionInfo: sessionInfo,
      emailId,
      command: "SEND_CHAT_TRANSCRIPT_REQUEST",
      customerId,
      convoType: "TEXT",
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      firstMessageTimestamp: 0,
      uuId: uuid(),
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT  TRANSCRIPT", params);
      if (message) {
        return message;
      }
    });
  };

  const healthPing = (sessionId) => {
    const customerId = userData.customerId
    const clientUser = userData.clientChannel
    const params = {
      configId: s360ConfigService.config.configId,
      command: "HEALTH_PING",
      customerId,
      clientUser,
      fromUi: false,
      isJabber: false,
      fromApi: false,
      sessionId: sessionId,
      sourceType: userData.sourceType || 60,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR healthPing", params);
      if (message) {
        return message;
      }
    });
  };

  // Fire-and-forget presence signal telling backend the customer is still active
  const sendHeartbeat = (sessionId) => {
    const params = {
      configId: s360ConfigService.config.configId,
      command: "CUSTOMER_HEARTBEAT",
      customerId: userData.customerId,
      clientUser: userData.clientChannel,
      sessionId: sessionId,
      sourceType: userData.sourceType || 60,
      fromUi: false,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      timestamp: Date.now(),
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CUSTOMER_HEARTBEAT", params);
      if (message) {
        return message;
      }
    });
  };

  // Presence-gated "seen" signal for an agent/bot message the customer has viewed
  const sendMessageSeen = (sessionId, messageData, convoType) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const msgId = messageData.id;
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "MESSAGE_SEEN",
      customerId,
      message: messageData,
      convoType: convoType,
      customerFirstName: customerFirstName,
      customerLastName: customerLastName,
      appId: appId,
      msgId: msgId,
      fromUi: false,
      assignedTo: -1,
      sourceType,
      isJabber: false,
      fromApi: false,
      creator: "CUSTOMER",
      firstMessageTimestamp: 0,
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR MESSAGE_SEEN", params);
      if (message) {
        return message;
      }
    });
  };

  const sendGif = (sessionId, messageData, convoType) => {
    const customerId = userData.customerId
    const clientUser = userData.clientChannel
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const pageName = userData.pageName
    const appId = userData.appId
    const params = {
      msgId: messageData.id,
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "CUSTOMER_REPLY",
      customerId: customerId,
      message: messageData,
      convoType: convoType,
      clientUser: clientUser,
      customerFirstName: customerFirstName,
      typing: false,
      appId: appId,
      fromUi: false,
      assignedTo: -4,
      pageName: pageName,
      firstMessageTimestamp: 0,
      sourceType: sourceType,
      isJabber: false,
      fromApi: false,
    };
    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG:MESSAGE FOR CHAT sendGif ", params);
      if (message) {
        return message;
      }
    });
  };

  const sendTypingIndicatorMessage = (sessionId, isTyping) => {
    const customerId = userData.customerId
    const sourceType = userData.sourceType
    const sourceId = userData.sourceId
    const customerFirstName = userData.customerFirstName
    const customerLastName = userData.customerLastName
    const appId = userData.appId
    const params = {
      configId: s360ConfigService.config.configId,
      sourceId: sourceId,
      sessionId: sessionId,
      command: "TYPING_INDICATOR",
      customerId,
      customerFirstName,
      customerLastName,
      appId,
      sourceType,
      typer: "CUSTOMER",
      typing: isTyping
    };

    cometd.publish(sendURl, JSON.stringify(params), function ack(message) {
      console.log("COMETD-LOG: TYPING_INDICATOR ", params);
      if (message) {
        return message;
      }
    });
  };

  return {
    fetchConversationsCMD: fetchConversations,
    createSessionCMD: createSession,
    fetchHistoryCMD: fetchHistory,
    sendMessageCMD: sendMessage,
    saveUserMetaData: saveUserMetaData,
    closeSessionCMD: closeSession,
    changeLanguageCometd: changeLanguage,
    sendChatTranscriptCMD: sendChatTranscript,
    sendAckAgentMessage: sendAckAgentMessage,
    sendGif: sendGif,
    sendBotAckMessage: sendBotAckMessage,
    sendHealthPing: healthPing,
    sendHeartbeat: sendHeartbeat,
    sendMessageSeen: sendMessageSeen,
    sendTypingIndicatorMessage
  };
};
